import apiClient from '../utils/apiClient';

/**
 * Obtiene la lista de destinos que coinciden con la búsqueda
 * 
 * @param {string} destination - Palabra o frase a buscar
 * @returns {Promise<Array< Destination >>} - La lista de destinos que coinciden con la búsqueda
 */
export const getDestinations = async (destination, pais) => {
  try {
    const response = await apiClient.get(`/busqueda/motor?filtro=${destination}${pais}`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
/**
 * Obtiene la disponibilidad de hoteles en base a las habitaciones proporcionadas.
 * 
 * @param {Array} arrAlojamientos - Arreglo de id y tipo de destino.
 * @returns {Promise<Object>} - Un objeto con los hoteles.
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getHotels = async (arrAlojamientos) => {
  try {
    const response = await apiClient.post(`/hoteles`, arrAlojamientos);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
/**
 * Obtiene la disponibilidad de hoteles en base a las habitaciones proporcionadas.
 * 
 * @param {Array} arrRooms - Arreglo de objetos con la información de cada habitación. Cada objeto debe tener las siguientes propiedades:
 *  - idAlojamiento: {number} - El ID del alojamiento (hotel, apartahotel, etc.).
 *  - idHabitacion: {number} - El ID de la habitación.
 *  - tipoHabitacion: {string} - El tipo de habitación (Individual, Doble, Triple, etc.).
 *  - cantidadHabitaciones: {number} - La cantidad de habitaciones a reservar.
 * @returns {Promise<Object>} - Un objeto con la disponibilidad de cada habitación.
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getHotelAvailability = async (arrRooms) => {
  try {
    const response = await apiClient.post(`/hoteles/disponibilidad`, arrRooms);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
export const getSimilarDestinations = async (arrRooms) => {
  try {
    const response = await apiClient.post(`/carousel/ficha_hotel`, arrRooms);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/**
 * Obtiene las tasas de cada habitación en base a las fechas de checkin y checkout.
 *
 * @param {Array} arrRates - Arreglo de objetos con la información de cada habitación. Cada objeto debe tener las siguientes propiedades:
 *  - idHabitacion: {number} - El ID de la habitación.
 *  - checkin: {string} - La fecha de checkin en formato ISO (yyyy-MM-dd).
 *  - checkout: {string} - La fecha de checkout en formato ISO (yyyy-MM-dd).
 * @returns {Promise<Object>} - Un objeto con la tasa de cada habitación.
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getHotelesRate = async (arrRates) => {
  try {
    const response = await apiClient.post(`/hoteles/rate`, arrRates);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const getHotelesRateHdo = async (arrRates) => {
  try {
    const response = await apiClient.post(`/hoteles/rate/hdo`, arrRates);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const getHotelesRatePtc = async (arrRates) => {
  try {
    const response = await apiClient.post(`/hotelesPrice/hold`, arrRates);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/**
 * Retrieves available filters for hotel searches.
 *
 * @returns {Promise<Object>} - An object containing various filters for hotels.
 * @throws {Error} - Throws an error if the request fails.
 */

export const getHotelFilters = async (idDestino) => {
  try {
    const response = await apiClient.get(`/hoteles/filtros/${idDestino}`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

/** 
 * Actividades Bol
 */

export const getActividades = async (arrActividades) => {
  try {
    const response = await apiClient.post(`/actividades`, arrActividades);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const getDestinationsAct = async (destinationAct) => {
  try {
    const response = await apiClient.get(`/busqueda/motoract?filtro=${destinationAct}`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const getActvidadDetalle = async (arrActividades) => {
  try {
    const response = await apiClient.post(`/actividades/detalles/completo`, arrActividades);    
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const getActividadesFilters = async (idDestino) => {
  try {
    const response = await apiClient.post(`/actividades/filtrosDinamicos`, idDestino);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const getTerminalesPaisTraslados = async (filtro, pais) => {
  try {
    const response = await apiClient.get(`/terminales/pais?filtro=${filtro}&pais=${pais}`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const getTrasladosDisponibilidad = async (arrTraslados) => {
  try {
    const response = await apiClient.post(`/traslados/disponibilidad`, arrTraslados);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};


export const getCountriesCode = async () => {
  try {
    const response = await apiClient.get(`/pais`);
    return response?.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};